import type { DefaultNamespace, ParseKeys, TOptions } from '@if/core/i18n'
import { EProvince } from '@if/core/types'
import { FundingComputedDto } from '@src/data/types/FundingComputedDto'
import { ProvinceConfigs } from '@src/data/types/ProvinceConfigs'

export type WorksheetErrorMessageArgs = Omit<TOptions, 'context'> & { context?: string }

export interface WorksheetError {
  code: string
  messageKey: ParseKeys<DefaultNamespace>
  messageArgs?: WorksheetErrorMessageArgs
}

interface AprValidatorInput {
  computedInfo: FundingComputedDto | null
  stateIso: EProvince | undefined
  effectiveRateThreshold: number
  provinceConfigs: ProvinceConfigs
}

// Backend parity: Newfoundland uses the province high-cost rate; rejects only when strictly above threshold.
export const validateApr = ({
  computedInfo,
  stateIso,
  effectiveRateThreshold,
  provinceConfigs,
}: AprValidatorInput): WorksheetError | null => {
  if (!computedInfo) return null
  const effectiveRate = computedInfo.effectiveRate ?? 0
  const nlRate = stateIso === EProvince.Newfoundland ? (provinceConfigs[stateIso]?.highCostRate ?? 0) : 0
  const threshold = nlRate > 0 ? nlRate : effectiveRateThreshold
  if (threshold <= 0 || effectiveRate <= threshold) return null
  return {
    code: 'aprTooHigh',
    messageKey: 'worksheetCommon.errors.aprTooHigh',
    messageArgs: { threshold, effectiveRate, stateIso },
  }
}

